import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ConfigService } from '../shared/utils/config.service';
import { BaseService } from '../shared/services/base.service';

@Injectable()
export class NavMenuVersionService extends BaseService{
  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json'
  });
  baseUrl: string = '';

  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
    this.baseUrl = configService.getApiURI();
  }

  getAppVersion(): Observable<any> {
    return this.http.get<any[]>(this.baseUrl + '/NavMenu/GetAppVersion');
  };

}
